<!--<div class="theme-hide theme-gradient-bg theme-gradient-bg-people"></div>-->
<div class="card" *ngIf="auth.hasFeature('SearchStudents') || auth.hasFeature('SearchFaculty') || auth.hasFeature('SearchAllPeople')">
    
    <div class="card-header card-header-tabs">
        <!-- NAVIGATION TABS-->
        <ul class="nav nav-tabs">
            <li class="nav-item" *ngIf="auth.hasFeature('SearchStudents')">
                <a [ngClass]="{'active': mainTabToShow == 'main-classmates'}" class="nav-link active" href="#main-classmates" (click)="mainTabToShow='main-classmates'"
                   data-bs-toggle="tab" role="tab" aria-controls="main-classmates" aria-selected="true">Classmates</a>
            </li>
            <li class="nav-item" *ngIf="auth.hasFeature('SearchFaculty')">
                <a [ngClass]="{'active': mainTabToShow == 'mystudents'}" class="nav-link" href="#mystudents" (click)="mainTabToShow='mystudents'"
                   data-bs-toggle="tab" role="tab" aria-controls="mystudents" aria-selected="true">My Students</a>
            </li>
            <li class="nav-item" *ngIf="auth.hasFeature('SearchAllPeople')">
                <a [ngClass]="{'active': mainTabToShow == 'searchallpeople'}" class="nav-link" href="#searchallpeople" (click)="mainTabToShow='searchallpeople'"
                   data-bs-toggle="tab" role="tab" aria-controls="searchallpeople" aria-selected="true">Search All People</a>
            </li>

        </ul>
    </div>
    <div class="card-body">
        <div class="tab-pane fade" *ngIf="auth.hasFeature('SearchStudents')" [ngClass]="{'active show': mainTabToShow == 'main-classmates'}" id="main-classmates" role="tabpanel" aria-labelledby="main-classmates">
            <div class="input-group input-group-sm input-group-alt has-clearable dropdown">
                <ng-container *ngIf="people.network$ | async; else loadingFilter">
                    <label class="mb-1 col-form-label-lg" for="network-search">Filter &nbsp;</label>
                    <input class="form-control form-control-sm search-filter" type="text" aria-label="search" id="network-search" [formControl]="searchTermControl"
                           placeholder='e.g. finance' data-bs-toggle="dropdown" autocomplete="off">
                    <div id="search-dropdown" *ngIf="typeAhead$ | async as hints" class="dropdown-menu" role="menu">
                        <i id="search-spinner" *ngIf="isSearching" class="fas fa-circle-notch fa-spin"></i>
                        <div *ngFor="let hint of hints | keyvalue" class="dropdown-item dropdown-header d-block p-0" role="menuitem">
                            <h6 class="dropdown-header">{{hint.key}}:</h6>
                            <span *ngFor="let val of hint.value | keyvalue" (click)="updateSearch(val.key, hint.key)" class="dropdown-item" role="menuitem">{{val.key}} ({{val.value}})</span>
                        </div>
                    </div>
                </ng-container>
                <ng-template #loadingFilter>
                    <div class="widget-action-loading text-center">
                        <div class="typing">
                            <span class="dot"></span>
                            <span class="dot"></span>
                            <span class="dot"></span>
                        </div>
                    </div>
                </ng-template>

            </div>
            <nav class="page-navs">
                <div class="nav-scroller">
                    <div class="nav nav-center nav-tabs mini-tabs" role="tablist">
                        <a class="nav-link" [ngClass]="{'active show': tabToShow == 'classmates'}" href="#classmates" data-bs-toggle="tab" role="tab" aria-controls="classmates" aria-selected="false">
                            Classmates <span *ngIf="classmatesCount > 0">({{classmatesCount}})</span>
                        </a>
                        <a class="nav-link" [ngClass]="{'active show': tabToShow == 'classof'}" href="#classof" data-bs-toggle="tab" role="tab" aria-controls="classof" aria-selected="false">
                            Class <span *ngIf="classOfCount > 0">({{classOfCount}})</span>
                        </a>
                        <a class="nav-link" *ngIf="auth.hasFeature('StudyGroups')" [ngClass]="{'active show': tabToShow == 'legacy'}" href="#legacy" data-bs-toggle="tab" role="tab" aria-controls="legacy" aria-selected="false">
                            {{legacyName$ | async}} <span *ngIf="legacyCount > 0">({{legacyCount}})</span>
                        </a>
                        <a class="nav-link" [ngClass]="{'active show': tabToShow == 'mygroups'}" href="#mygroups" data-bs-toggle="tab" role="tab" aria-controls="mygroups" aria-selected="false">
                            My Groups
                        </a>
                    </div>
                </div>
            </nav>

            <div class="tab-content">
                <!-- CLASSMATES TAB -->
                <div class="tab-pane fade" [ngClass]="{'active show': tabToShow == 'classmates'}" id="classmates" role="tabpanel">
                    <div *ngIf="classmates$ | async as people; else loading">
                        <div *ngIf="sections$ | async as sectionGroups">
                            <div class="row alert alert-primary justify-content-md-center">
                                <div class="col-md-8">
                                    <span class="col-form-label">My Courses &nbsp;</span>

                                    <select class="form-select" [formControl]="selectedSectionControl" required>
                                        <!--<option value="" selected> -- Select a Course -- </option>-->
                                        <option value="" selected> -- Show all Classmates --</option>
                                        <optgroup *ngFor="let sectionGroup of sectionGroups" label="{{sectionGroup.label}}">
                                            <option *ngFor="let section of sectionGroup.sections" value="{{section.id}}">{{section.name}}</option>
                                        </optgroup>


                                        <option *ngFor="let section of sections" value={{section.id}}>
                                            <ng-container *ngIf="parseDate(section.EndDate) < parseDate(currentDate)">Previous - </ng-container>
                                            {{section.name}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <app-person-list [data]="people" [searchterm]="searchTermControl.value" class="row"></app-person-list>
                        </div>
                    </div>
                </div>

                    <!-- CLASS OF TAB -->
                    <div class="tab-pane fade" [ngClass]="{'active show': tabToShow == 'classof'}" id="classof" role="tabpanel">
                        <div *ngIf="classOf$ | async as people; else loading">
                            <app-person-list [data]="people" [searchterm]="searchTermControl.value" class="row"></app-person-list>
                        </div>
                    </div>

                    <!-- LEGACY TAB -->
                    <div class="tab-pane fade" [ngClass]="{'active show': tabToShow == 'legacy'}" id="legacy" role="tabpanel">
                        <div *ngIf="legacy$ | async as people; else loading">
                            <app-person-list [data]="people" [searchterm]="searchTermControl.value" class="row"></app-person-list>
                        </div>
                    </div>

                    <!-- MY GROUPS TAB -->
                    <div class="tab-pane fade" [ngClass]="{'active show': tabToShow == 'mygroups'}" id="mygroups" role="tabpanel">
                        <div class="alert alert-info" role="alert">
                            Select one or more profile cards from any of the classmates tabs to create a new group.<br /> Use the <i class="fas fa-sort-down align-text-top"></i> to edit a group or email its members.
                        </div>
                        <div class="row" >
                            <div class="container col-12" *ngIf="groups$ | async as groups; else loading">
                                <div class="row person-list">
                                    <div class="col-sm-6" *ngFor="let group of groups">
                                        <div class="card">
                                            <div class="card-header dropdown">
                                                {{group.Name}}

                                            <button class="dropdown-toggle edit-group float-right" type="button" data-bs-toggle="dropdown" data-bs-target="#open_{{group.Id}}" aria-expanded="false">
                                                <span class="sr-only">Group Options</span>
                                            </button>
                                            <div class="dropdown-menu" id="#open_{{group.Id}}">
                                                <button class="dropdown-item" (click)="emailGroup(group)" type="button"><i class="fa fa-lg fa-envelope card-action" aria-hidden="true"></i> Email All</button>
                                                <div class="dropdown-divider"></div>
                                                <button class="dropdown-item" (click)="people.deleteGroup(group.Id)"><i class="fas fa-user-times"></i> Delete Group</button>
                                            </div>

                                            </div>
                                            <ul class="list-group list-group-flush dropdown">
                                                <li *ngFor="let person of group.Members" class="list-group-item align-middle">
                                                    <img #profileImg
                                                         class="user-avatar"
                                                         src="{{person.photoUrl}}"
                                                         alt="{{person.PersonFirstLastName}}"
                                                         (error)="profileImg.src = person.failedPhotoUrl">
                                                    <span> {{person.PersonFirstLastName}} </span>

                                                    <button class="dropdown-toggle px-0" type="button" data-bs-toggle="dropdown" data-bs-target="#open_{{person.PersonId}}" aria-expanded="false">
                                                        <span class="sr-only">Person Options</span>
                                                    </button>
                                                    <div class="dropdown-menu" id="#open_{{person.PersonId}}">
                                                        <button class="dropdown-item btn"><a href="mailto:{{person.Email}}"><i class="fa fa-lg fa-envelope card-action" aria-hidden="true"></i> New Email</a></button>
                                                        <div class="dropdown-divider"></div>
                                                        <button class="dropdown-item" (click)="people.deleteFromGroup(group.Id, person.PersonId)"><i class="fas fa-user-times"></i> Remove</button>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                <!-- TODO: Is this used anywhere? -->
                <!--<ng-template #emailGroupModal let-modal>
                    <div class="modal-header">
                        <h4 class="modal-title" id="modal-basic-title">Email group</h4>
                        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        {{group.Name}}
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-primary" (click)="modal.close('email')">Email</button>
                    </div>
                </ng-template>-->
            </div>
                        <!-- The "Loading" template -->
            <ng-template #loading>
                <div class="widget-loading text-center">
                    <i class="fas fa-circle-notch fa-spin"></i>
                </div>
            </ng-template>

            </div>




            <div class="tab-pane fade" [ngClass]="{'active show': mainTabToShow == 'mystudents'}" id="mystudents" role="tabpanel" aria-labelledby="mystudents">
                <div *ngIf="classmates$ | async as people; else loadingfaculty">
                    <div *ngIf="sections$ | async as sections">
                    <div class="row alert alert-primary justify-content-md-center">
                        <div [ngClass]="selectedSectionControl.value > 0 ? 'col-md-9 col-lg-10' : 'col-12'">
                            <span class="col-form-label"></span>My Current and Future Courses &nbsp;
                            <select class="form-select" [formControl]="selectedSectionControl" required>
                                <option value="0" selected>-- [all sections] -- </option>
                                <ng-container *ngFor="let section of sections">
                                    <option value={{section.SectionId}}>{{section.DisplayNameStudents}}</option>
                                </ng-container>
                            </select>
                        </div>
                        <div class="col-sm-3 col-lg-2 px-0 pt-4">
                            <app-people-download-buttons *ngIf="selectedSectionControl.value > 0" [sectionId]="selectedSectionControl.value"></app-people-download-buttons>
                        </div>
                    </div>
                    <app-person-list [data]="people" [searchterm]="searchTermControl.value" class="row"></app-person-list>

                    </div>
                </div>

                <ng-template #loadingfaculty>
                    <div class="widget-loading text-center">
                        <i class="fas fa-circle-notch fa-spin"></i>
                    </div>
                </ng-template>
            </div>




            <!-- Advanced Search -->
            <div class="tab-pane fade" [ngClass]="{'active show': mainTabToShow == 'searchallpeople'}" id="searchallpeople" role="tabpanel" aria-labelledby="searchallpeople">

            <form class="form advanced-menu" *ngIf="util.filterLookups$ | async as lookups; else loading" #f="ngForm">
                <div class="form-row">
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="searchType" id="searchType1" value="CurrentStudents" [(ngModel)]="searchType">
                        <label class="form-check-label" for="searchType1">Current Students</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="searchType" id="searchType2" value="Faculty" [(ngModel)]="searchType">
                        <label class="form-check-label" for="searchType2">Faculty</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="searchType" id="searchType3" value="Staff" [(ngModel)]="searchType">
                        <label class="form-check-label" for="searchType3">Staff</label>
                    </div>
                </div>
                <div *ngIf="searchType=='CurrentStudents'" class="row">
                    <div class="form-group col-md-2">
                        <multi-selector-dropdown #multiPrograms [(container)]="formObject" [list]="lookups.programs.Keywords" field="programs"
                                                 [defaultCheckedItems]="[defaultProgram]" id="program" labelText="Program" [labelCols]="12" [indent]="3"
                                                 (shareCheckedList)="setProgram($event)">
                        </multi-selector-dropdown>
                    </div>
                    <div class="form-group col-md-2" *ngIf="hasKeywords(lookups.classOfs, program)">
                        <label class="mb-0 col-form-label-sm" for="classOfSelect">Class Of</label>
                        <select class="form-select form-select-sm mb-1" id="classOfSelect" name="ClassOf" [(ngModel)]="classOf">
                            <option *ngFor="let class of lookups.classOfs.Keywords" [value]="class.Value" [text]="class.Text">
                                {{class.Text}}
                            </option>
                        </select>
                    </div>
                    <div class="form-group col-md-2" *ngIf="hasKeywords(lookups.cohorts, program)">
                        <label class="mb-0 col-form-label-sm" for="cohortSelect">Cohort</label>
                        <select class="form-select form-select-sm mb-1" id="cohortSelect" name="Cohort" [(ngModel)]="cohort">
                            <option *ngFor="let cohort of lookups.cohorts.Keywords" [value]="cohort.Value" [text]="cohort.Text">
                                {{cohort.Text}}
                            </option>
                        </select>
                    </div>
                    <div class="form-group col-md-2" *ngIf="hasKeywords(lookups.entryYears, program)">
                        <label class="mb-0 col-form-label-sm" for="entryYearSelect">Entry Year</label>
                        <select class="form-select form-select-sm mb-1" id="entryYearSelect" name="EntryYear" [(ngModel)]="entryYear">
                            <option *ngFor="let year of lookups.entryYears.Keywords" [value]="year.Value" [text]="year.Text">
                                {{year.Text}}
                            </option>
                        </select>
                    </div>
                    <div class="form-group col-md-2" *ngIf="hasKeywords(lookups.legacies, program)">
                        <label class="mb-0 col-form-label-sm" for="legacySelect">Engagement Team</label>
                        <select class="form-select form-select-sm mb-1" id="legacySelect" name="Legacy" [(ngModel)]="legacy">
                            <option *ngFor="let legacy of lookups.legacies.Keywords" [value]="legacy.Value" [text]="legacy.Text">
                                {{legacy.Text}}
                            </option>
                        </select>
                    </div>
                    <div class="form-group col-md-2" *ngIf="hasKeywords(lookups.classifications, program)">
                        <label class="mb-0 col-form-label-sm" for="classificationSelect">Year</label>
                        <select class="form-select form-select-sm mb-1" id="classificationSelect" name="Classification" [(ngModel)]="classification">
                            <option *ngFor="let classification of lookups.classifications.Keywords" [value]="classification.Value" [text]="classification.Text">
                                {{classification.Text}}
                            </option>
                        </select>
                    </div>
                    <div class="form-group col-md-2" *ngIf="program == 'UBP' || program == 'MBA'">
                        <label class="mb-0 col-form-label-sm" for="exchangeSelect">Exchange</label>
                        <select class="form-select form-select-sm mb-1" id="exchangeSelect" name="Exchange" [(ngModel)]="exchange">
                            <option value="0"></option>
                            <option value="1">Only Exchange Students</option>
                            <option value="2">Exclude Exchange Students</option>
                        </select>
                    </div>
                </div>
                <div *ngIf="searchType=='Faculty'" class="form-row">
                    <div class="form-group col-md-2">
                        <label class="mb-0 col-form-label-sm" for="areaSelect">Academic Area</label>
                        <select class="form-select form-select-sm mb-1" id="areaSelect" name="AcademicArea" [(ngModel)]="academicArea">
                            <option *ngFor="let area of lookups.areas.Keywords | excludeItems: ['Healthcare', 'Energy']: 'Value'" [value]="area.Value" [text]="area.Text">
                                {{area.Text}}
                            </option>
                        </select>
                    </div>
                </div>
                <div *ngIf="searchType=='Staff'" class="form-row">
                    <div class="form-group col-md-6">
                        <label class="mb-0 col-form-label-sm" for="divisionSelect">Department</label>
                        <select class="form-select form-select-sm mb-1" id="divisionSelect" name="Division" [(ngModel)]="division">
                            <option *ngFor="let department of lookups.departments.Keywords" [value]="department.Value" [text]="department.Text">
                                {{department.Text}}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-4 has-clearable">
                        <label class="mb-0 col-form-label-sm" for="advancedSearch">Search Profile</label>
                        <input type='search' class='form-control form-control-sm' id="advancedsearch" aria-label='AdvancedSearch' name="searchTerm" placeholder='e.g. name, title, etc.'
                               [(ngModel)]="searchTerm" (keydown.enter)="onAdvancedSearch()" />
                    </div>
                </div>
                <div *ngIf="advancedSearchError != ''" class="alert alert-danger mt-1 mb-1">
                    {{advancedSearchError}}
                </div>
                <button type="button" class="btn btn-sm btn-primary mt-3 me-1 " (click)="onAdvancedSearch()" [disabled]="isAdvancedSearchRunning">
                    Search
                    <span *ngIf="isAdvancedSearchRunning" class="loader loader-sm loader-light" role="status" aria-hidden="true"></span>
                    <span class="sr-only">Search</span>
                </button>
                <button type="button" class="btn btn-sm btn-outline-primary mt-3" [disabled]="isSearchRunning" (click)="resetSearchFields(f, lookups.defaults )">
                    Reset
                    <span class="sr-only">Reset</span>
                </button>
            </form>



                <div class="advanced-search-results">
                    <div *ngIf="advancedSearch$ | async as peopleByProgram">
                        <div class="col-12 search-title"><strong>{{getTotalPeople(peopleByProgram)}} results for "{{searchTerm}}"</strong></div>
                        <app-person-list [data]="peopleByProgram" [byprogram]="true" class="row advanced-search-person-list"></app-person-list>
                    </div>
                </div>
                <!-- The "Loading" template -->
                <ng-template #loading>
                    <div class="widget-loading text-center">
                        <i class="fas fa-circle-notch fa-spin"></i>
                    </div>
                </ng-template>

            </div>
        </div>
    </div>

<div class="" *ngIf="!auth.hasFeature('SearchStudents') && !auth.hasFeature('SearchFaculty') && !auth.hasFeature('SearchAllPeople')">
    No search available.
</div>
